export enum BrochureCartState {
  LOADING = 'loading',
  EMPTY = 'empty',
  LISTING = 'listing',
  ERROR = 'error',
}

export enum EDirection {
  up = "up",
  down = "down",
}